export const TRANSACTION_COUNT_PER_PAGE = 10;
export const TRANSACTION_COUNT_PER_PAGE_IN_MOBILE = 5;
